module.exports = __webpack_public_path__ + "static/media/subcon.4d3e4620.svg";